export default class GoogleMapsHelper {
    public static mapInstance: any = null;
    public static autocompleteService: any = null;
    public static geocoder: any = null;
    public static mapMarkers: any[] = [];
    public static infoWindows: any[] = [];
    public static activeInfoWindowId: any = null;

    static loader = new (<any>window).Loader({
        apiKey: (<any>document.getElementById("GoogleMapsAPIKey"))?.value,
        version: "weekly",
        libraries: ["core", "maps", "marker", "places"]
    });

    static mapOptions = {
        center: { lat: 44.48616829197657, lng: 11.101396940428318 },
        zoom: 11,
        minZoom: 8,
        maxZoom: 18,
        mapId: "d2fb4ecf62804fcd",
        disableDefaultUI: false,
        clickableIcons: false,
        zoomControl: true,
        zoomControlOptions: {
            position: 0
        },
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    }

    static async loadMap() {
        let self = this;

        navigator?.permissions?.query({ name: "geolocation" }).then((permissionStatus) => {
            permissionStatus.onchange = () => {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        const { latitude, longitude } = position.coords;
                        self.setCenter(latitude, longitude);
                        self.mapInstance.setZoom(11);
                    }
                );
            };
        });

        navigator?.geolocation?.getCurrentPosition(
            position => {
                const { latitude, longitude } = position.coords;
                this.mapOptions.center = { lat: latitude, lng: longitude }
            }
        );

        await this.loader.importLibrary("maps").then(async ({ Map }) => {
            self.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.TOP_RIGHT;
            self.mapInstance = new Map(document.getElementById("GoogleMap") as HTMLElement, self.mapOptions);
        });
    }

    static getBounds() {
        return this.mapInstance.getBounds();
    }

    static setCenter(lat: number, lng: number) {
        this.mapInstance.setCenter(new google.maps.LatLng(lat, lng));
    }

    static addMarker(id: string, lat: number, lng: number, type: string, title: string, infowindowContent: string) {
        const self = this;

        let content = document.createElement("img");
        content.src = "/images/marker.svg";
        content.alt = title;

        const infowindow = new google.maps.InfoWindow({
            content: infowindowContent,
            ariaLabel: title,
            disableAutoPan: true
        });

        infowindow.set("id", id);

        infowindow.addListener("closeclick", () => {
            this.activeInfoWindowId = null;
        });

        this.infoWindows.push(infowindow);

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.mapInstance,
            position: { lat: lat, lng: lng },
            content: content,
            title: title,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL
        });

        marker.id = id;

        marker.addListener("click", () => {
            for (const item of this.infoWindows) {
                item.close();
            }

            this.activeInfoWindowId = id;

            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });
        });

        this.mapMarkers.push(marker);

        if (this.activeInfoWindowId == id) {
            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });
        }
    }

    static clickMarker(markerId: string) {
        let marker = this.mapMarkers.find(x => x.id === markerId);
        if (marker) {
            let infowindow = this.infoWindows.find(x => x.id === markerId);

            for (const item of this.infoWindows) {
                this.activeInfoWindowId == null;
                item.close();
            }

            infowindow.open({
                anchor: marker,
                map: this.mapInstance,
                shouldFocus: true
            });

            this.activeInfoWindowId = markerId;
        }
    }

    static removeMarkers() {
        for (const item of this.infoWindows) {
            item.close();
        }

        this.infoWindows = [];

        for (const item of this.mapMarkers) {
            item.map = null;
        }

        this.mapMarkers = [];
    }

    static setActiveInfoWindowId(id: string) {
        if (this.activeInfoWindowId !== null) {
            for (const item of this.infoWindows) {
                item.close();
            }
        }

        this.activeInfoWindowId = id;
    }

    static getAutocompleteService() {
        if (!this.autocompleteService) {
            this.autocompleteService = new google.maps.places.AutocompleteService();
        }
        return this.autocompleteService;
    }

    static getGeocoder() {
        if (!this.geocoder) {
            this.geocoder = new google.maps.Geocoder();
        }
        return this.geocoder;
    }
}